import {
  type AiBuilderMessage,
  type AiBuilderResponseFeedback,
} from '../stores/types';

export type AiBuilderResponseFeedbackTargetMessage = Extract<
  AiBuilderMessage,
  { kind: 'assistant' | 'choice' | 'confirm' }
>;

export const isAiBuilderResponseFeedbackTarget = (
  message: AiBuilderMessage,
): message is AiBuilderResponseFeedbackTargetMessage =>
  message.kind === 'assistant' ||
  message.kind === 'choice' ||
  message.kind === 'confirm';

export const getNextAiBuilderResponseFeedback = (
  current: AiBuilderResponseFeedback,
  clicked: Exclude<AiBuilderResponseFeedback, null>,
): AiBuilderResponseFeedback => (current === clicked ? null : clicked);

export const updateAiBuilderResponseFeedbackState = (
  messages: AiBuilderMessage[],
  messageId: string,
  state: {
    feedback: AiBuilderResponseFeedback;
    pending: boolean;
  },
): AiBuilderMessage[] =>
  messages.map(message =>
    message.id === messageId && isAiBuilderResponseFeedbackTarget(message)
      ? {
          ...message,
          feedback: state.feedback,
          feedbackPending: state.pending,
        }
      : message,
  );
